import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import UploadedFilesTableSection from './UploadedFilesTableSection';
import UploadFileInstructionsSection from './UploadFileInstructionsSection';
import { 
  UPLOAD_FILES_MODAL_I18N_KEYS as MY_I18N_KEYS, 
  UPLOAD_FILES_MODAL_I18N_PREFIX as MY_I18N_PREFIX 
} from '../constants/i18n/UploadFilesModali18nConstants';


class UploadFilesModal extends Component {
  static propTypes = {
    show:                                PropTypes.bool.isRequired,
    toggleModal:                         PropTypes.func.isRequired,
    topicData:                           PropTypes.object.isRequired,
    handleFileValidation:                PropTypes.func.isRequired,
    handleFileUpload:                    PropTypes.func.isRequired,
    handleFinishUploadDataTopicCreation: PropTypes.func.isRequired,
    allUploadedData:                     PropTypes.array.isRequired
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (this.props.show) {
      document.body.classList.add('modal-open');
    }
  }

  getI18nText(textKey,params={}) {
    return t(MY_I18N_PREFIX + "." + textKey,params);
  }


  render() {
    const {
      toggleModal,
      show,
      topicData,
      allUploadedData
    } = this.props;

    return (
      <div className={`modal create-upload-data-topic-modal ${show ? 'modal-show' : 'modal-hide'}`}>
        <div className="modal-dialog">
          <div className="modal-content"> 
              <div className="modal-header">
                <div className="step-container">
                  <div className="circle">
                    <p>{this.getI18nText(MY_I18N_KEYS.step_two)}</p>
                  </div>
                  <span className="create-upload-data-topic-modal-title">
                    {this.getI18nText(MY_I18N_KEYS.modal_title, {topicName:topicData.topicName})}
                  </span>
                </div>
                <button
                  onClick={() => toggleModal(false)}
                  onKeyDown={() => {}}
                >
                  <i className="la la-close modal-close"/>    
                </button>
              </div>
            <div className='upload-files-modal-body modal-body'>
              <UploadFileInstructionsSection
                handleFileValidation={e => this.props.handleFileValidation(e)}
                handleFileUpload={e => this.props.handleFileUpload(e)}
              />

              {allUploadedData.length > 0 && (
                <div className='upload-files-info'>
                  <UploadedFilesTableSection
                    allUploadedData={allUploadedData}
                  />
                </div>
              )}
            </div>
            <div className="modal-footer">
              {allUploadedData.length === 0 && (
                <button
                  type="button"
                  className="btn fixed-width-btn"
                  onClick={() => toggleModal(false)}
                >
                  {this.getI18nText(MY_I18N_KEYS.cancel_button_text)}
                </button>
              )}
              <button
                type="submit"
                className='btn btn-submit fixed-width-btn'
                onClick={() => this.props.handleFinishUploadDataTopicCreation()}
                disabled={allUploadedData.length === 0}
              >
                {this.getI18nText(MY_I18N_KEYS.done_button_text)}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default UploadFilesModal;


// WEBPACK FOOTER //
// ./src/features/topics/components/file-upload/UploadFilesModal.js